import { render, staticRenderFns } from "./form-admin.vue?vue&type=template&id=12e201b4&"
import script from "./form-admin.vue?vue&type=script&lang=js&"
export * from "./form-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports